import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import swal from 'sweetalert';
import Config from './components/ClientConfig';
import Client from './components/Client';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#273442",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

class DataRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {   
      client: new Client ( "none" ),   
      edit: false,
      row: {},
      keyValid: false,
      valueValid: false,
      somethingHasChanged: false,
    };

    this.handleEditClick = this.handleEditClick.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.pushData = this.pushData.bind(this);

  }

  componentDidMount() {
    let row = {};
    if ( this.props.row ) {
      row = this.props.row;
      this.setState ( { row: row } );
      if ( row.key.length > 0 ) this.setState ( {keyValid: true } );
      if ( row.value.length > 0 ) this.setState ( {valueValid: true } );
    }
    if ( this.props.edit ) this.setState ( { edit: true } );
  }

  handleEditClick ( ) {
    this.setState({ edit: !this.state.edit });
  }

  changeValue ( e ) {
    let id = null;
    if ( e.target.id !== null ) id = e.target.id;
    let value = null;
    if  ( e.target.value !== null ) value = e.target.value;
    //if ( id !== null && value !== null && value !== undefined ) {
    if ( id ) {
      let row = {};
      if ( this.state.row ) row = this.state.row;
      switch ( id ) {
        case "key":
          if ( value.length > 0 ) {
            row.key = value;
            this.setState ( { keyValid: true });
          } else {
            row.key = "";
            this.setState ( { keyValid: false });
          }
          this.setState ( { somethingHasChanged: true } );
          break;
        case "value":
          if ( value.length > 0 ) {
            row.value = value;
            this.setState ( { valueValid: true });
          } else {
            row.value = "";
            this.setState ( { valueValid: false });
          }
          this.setState ( { somethingHasChanged: true } );
          break;
        case "description":
          row.description = value || "";
          this.setState({ somethingHasChanged: true });
          break;
        default:
          console.warn(`Unhandled id: ${id}`);
          break;
      }
      this.setState ( { row: row });
    }
  }

  pushData ( e ) {
    if ( this.state.somethingHasChanged && this.state.keyValid && this.state.valueValid ) {
      let rdata = this.state.client.pushData ( Config.API_URL_CONFIG_WEBSITE_ADD, this.state.row );
      if ( rdata ) {
        if ( rdata.status === "OK" ) {
          let uRow = this.state.row;
          uRow.iref = rdata.data?.iref;
          this.setState ( { row: uRow } );
          this.handleEditClick ( );
          swal ( "Success", "Successfully added/modified configuration value ! (" + rdata.iref + ")", "success", {
            buttons: false,
            timer: 2000,
          })
          .then((value) => {
            //this.props.personUpdated ( );
            this.setState ( {edit: false} );
            this.setState ( { somethingHasChanged: false } );
            this.props.rowAdded ();
          });        
        } else {
          if ( rdata.message ) this.setState ( { errorMessage: rdata.message } );
          swal ( "Error", "Add/Update configuration value failed !\n\n" + rdata.message, "error" );
        }
      }
    } else {
      swal ( "Error", "Add/Update configuration value failed ! Some fields are not validated !", "error" );
    }
  }

  render() {
    let row = {};
    let iref = "0";
    let key = "";
    let value = "";
    let description = "";
    if ( this.state.row ) {
      row = this.state.row;
      if ( row.iref ) iref = row.iref;
      if ( row.key ) key = row.key;
      if ( row.value ) value = row.value;
      if ( row.description ) description = row.description;
    }
    if ( this.props.dataRow !== null && this.props.dataRow !== undefined ) {
      row = this.props.dataRow;
    }

    let showSave = false;
    if ( this.state.edit === true && this.state.somethingHasChanged === true && this.state.keyValid === true && this.state.valueValid === true )
      showSave = true;

    return (
      <StyledTableRow key={row.iref}>
        <StyledTableCell align="left">
          {iref}
        </StyledTableCell>
        <StyledTableCell scope="row">
          {this.state.edit ? 
          <TextField
            id="key"
            label="Key"
            variant="outlined"
            value={key || ''}
            onChange={this.changeValue}
            onFocus={event => { event.target.select(); }}
            inputProps={{maxLength:"64"}}
            error={this.state.keyValid === false}
            required={true}
            sx={{minWidth: "360px"}}
            autoFocus={!!this.props.autoFocusKey}
          />
          : key }
        </StyledTableCell>
        
        <StyledTableCell align="left">
          {this.state.edit ? 
            <TextField
              id="value"
              label="Value"
              variant="outlined"
              value={value || ''}
              onChange={this.changeValue}
              onFocus={event => { event.target.select(); }}
              inputProps={{maxLength:"255"}}
              error={this.state.valueValid === false}
              required={true}
            />
            :value}
          </StyledTableCell>

        <StyledTableCell align="left">
          {this.state.edit ?
            <TextField
              id="description"
              label="Description"
              variant="outlined"
              value={description || ""}
              onChange={this.changeValue}
              multiline
              minRows={1}
              maxRows={3}
              sx={{ minWidth: "280px" }}
            />
            : description
          }
        </StyledTableCell>
        
        <StyledTableCell align="right">
          <IconButton aria-label="settings" onClick={this.handleEditClick}>
            <EditIcon
              sx={{ color: this.state.edit ? "#8f241d" : "#e3e3e5" }}              
            />
        </IconButton>
        {showSave ?
          <IconButton aria-label="settings" onClick={this.pushData}>
            <SaveIcon
              sx={{ color: "#4287f5" }}            
            />
      </IconButton>
        : ""}
        </StyledTableCell>
      </StyledTableRow>
    );
  }
}

class ConfigWebsite extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ),
      rows: null,
      edit: false,
      addRow: false,
      queryData: {},
      //addNewProduct: false,
    };

    this.rowAdded = this.rowAdded.bind(this);
    this.toggleAdd = this.toggleAdd.bind(this);
    this.getData = this.getData.bind(this);
    this.tableRef = React.createRef();
  }

  getData ( ) {
    let queryData = {};
    queryData[ "orderBy" ] = "key";
    this.setState ( { queryData: queryData } );
    let data = this.state.client.getData ( Config.API_URL_CONFIG_WEBSITE, queryData );
    this.setState ( { rows: data.WebsiteConfigs });
  }

  componentDidMount() {    
    this.getData ( );    
  }

  componentWillUnmount() {    
  }

  rowAdded ( ) {
    this.getData ( );
    this.setState ( { addRow: false } );
  }

  toggleAdd() {
    const addButton = this.state.addRow;
    this.setState({ addRow: !addButton }, () => {
      if (!addButton && this.tableRef.current) {
        // smooth scroll when opening the add row
        const el = this.tableRef.current;
        if (el.scrollTo) el.scrollTo({ top: 0, behavior: 'smooth' });
        else el.scrollTop = 0;
      }
    });
  }
  
  render() {
    let allData ="";
    if ( this.state.rows ) {
      if ( this.state.rows.length > 0 ) {
        let rows = this.state.rows;
        allData = rows.map((row) => {
          return <DataRow
            key={`${row.iref}-${row.key}-${row.value}-${row.description || ""}`}
            row = {row}
            rowAdded={this.rowAdded}
          />
        });
      }
    }

    return (
      <TableContainer component={Paper} sx={{ maxHeight: '90vh' }} ref={this.tableRef}>
      <Table stickyHeader sx={{ minWidth: 980 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>
              <IconButton aria-label="Add Location" title="Add Location" onClick={() => this.toggleAdd()}>       
                <Avatar alt="Add Location" sx={{ width: 24, height: 24, color: "#273442" }}>
                  {this.state.addRow ? <FaMinusCircle/> : <FaPlusCircle/>}
                </Avatar>
              </IconButton>
            </StyledTableCell>
            <StyledTableCell>
              Name
            </StyledTableCell>
            <StyledTableCell align="left">Value</StyledTableCell>
            <StyledTableCell align="left">Description</StyledTableCell>
            <StyledTableCell align="right">Action</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.state.addRow ?
          <DataRow key={0} edit={true} rowAdded={this.rowAdded} autoFocusKey/>
          : ""
          }
          {allData}
        </TableBody>
      </Table>
    </TableContainer>
    );
  }
}

export default ConfigWebsite;